import * as React from "react";
import { forwardRef } from "react";
const SvgMinus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 8.31055H11", stroke: "currentColor", strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
